import { render, staticRenderFns } from "./TradeEvaluation.vue?vue&type=template&id=1a1b0cf2&"
import script from "./TradeEvaluation.vue?vue&type=script&lang=js&"
export * from "./TradeEvaluation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports